export default "__VITE_ASSET__CWCvohkx__"